import { apiV2 } from 'shared';

export const verifyReferralCode = (code: string) => {
  return apiV2({
    url: `/payment_requests/verify-referral-code/?referral_code=${code}`,
    method: 'GET',
  });
};
